<template>
  <va-create-layout>
    <person-form :title="title" :item="item"></person-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
